import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LincesCommonModule } from '@docpath/linces-angular-components/common';
import { DpFormModule, DpHeaderModule, DpLoadingService, DpModalService, DpPaginationModule, DpSearchModule, DpTableModule, DpTabModule, DpToastService } from '@docpath/webcomponents';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';

import { AlertRulesModule } from './alert-rules/alert-rules.module';
import { AliasModule } from './alias/alias.module';
import { ConfigurationComponent } from './configuration.component';
import { EnginesModule } from './engines/engines.module';
import { FailedJobsModule } from './failed-jobs/failed-jobs.module';
import { GeneralComponent } from './general/general.component';
import { SelfMaintenanceModule } from './self-maintenance/self-maintenance.module';
import { ServicesModule } from './services/services.module';

@NgModule({
  declarations: [
    ConfigurationComponent,
    GeneralComponent
  ],
  imports: [
    CommonModule,
    DpFormModule,
    DpHeaderModule,
    DpPaginationModule,
    DpSearchModule,
    DpTableModule,
    DpTabModule,
    FontAwesomeModule,
    RouterModule,
    LincesCommonModule,
    TranslateModule,
    ServicesModule,
    AliasModule,
    AlertRulesModule,
    FailedJobsModule,
    EnginesModule,
    SelfMaintenanceModule
  ],
  providers: [
    DpLoadingService,
    DpModalService,
    DpToastService
  ],
  exports: [
  ]
})
export class ConfigurationModule { }
